import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2 = '[BenutzerverwaltungModul] PostBenutzerIncidentManagementSichtbarkeitAdmin2 laden';
export const POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerIncidentManagementSichtbarkeitAdmin2 ausführen';
export const POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerIncidentManagementSichtbarkeitAdmin2 laden erfolgreich';
export const POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_FEHLER = '[BenutzerverwaltungModul] PostBenutzerIncidentManagementSichtbarkeitAdmin2 Ladefehler';
export const POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerIncidentManagementSichtbarkeitAdmin2 nicht ausgeführt (evtl. Offline)';


export class PostBenutzerIncidentManagementSichtbarkeitAdmin2Action implements Action {
    readonly type = POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2;
        constructor(public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerIncidentManagementSichtbarkeitAdmin2AusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_AUSFUEHREN;
        constructor(public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerIncidentManagementSichtbarkeitAdmin2ErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerIncidentManagementSichtbarkeitAdmin2FehlerAction implements Action {
    readonly type = POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_FEHLER;
        constructor(public payload: any, public benutzerSichtbarkeitRequest: api.BenutzerSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerIncidentManagementSichtbarkeitAdmin2NichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_INCIDENT_MANAGEMENT_SICHTBARKEIT_ADMIN2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerIncidentManagementSichtbarkeitAdmin2Actions =
    PostBenutzerIncidentManagementSichtbarkeitAdmin2Action
    | PostBenutzerIncidentManagementSichtbarkeitAdmin2AusfuehrenAction
    | PostBenutzerIncidentManagementSichtbarkeitAdmin2ErfolgreichAction
    | PostBenutzerIncidentManagementSichtbarkeitAdmin2FehlerAction
    | PostBenutzerIncidentManagementSichtbarkeitAdmin2NichtAusgefuehrtAction
    ;
